import React from 'react';
import { FormattedTime } from 'react-intl';
import PropTypes from 'prop-types';

/**
 * Label para formatação de Horas
 * @param {Date} props.date data a extrair a hora
 * @author Fábio Sartori
 * @copyright 06/2019
 */
const HourLabel = ( { date } ) => (
    <FormattedTime value={date} 
                   hour="2-digit"
                   minute="2-digit"
    /> 
);
export default HourLabel;

HourLabel.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired
}